<template>
  <div>
    <p class="mb-5 has-text-centered" style="font-size: 1.1rem;">{{ message }}</p>
    <div class="buttons is-centered">
      <button
        @click="onClickStatusChange"
        class="button is-info is-medium"
        style="min-width: 200px; margin-bottom: 1rem;"
      >
        {{ buttonStatusText }}
      </button>
      <button
        @click="onClickTimingChange"
        class="button is-warning is-medium"
        style="min-width: 200px;"
      >
        {{ buttonTimingText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalOfferHandlingOptions',
  props: {
    message: {
      type: String,
      default: 'על מנת שההצעה הבאה תהיה שונה, יש לבחור באחת מהאפשרויות הבאות:'
    },
    buttonStatusText: {
      type: String,
      default: 'לשינוי סטטוס ומסג\''
    },
    buttonTimingText: {
      type: String,
      default: 'לשינוי מועד הטיפול בהצעה'
    },
    onStatusChange: {
      type: Function,
      default: () => {}
    },
    onTimingChange: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    onClickStatusChange () {
      const modalId = this.$attrs.payload ? this.$attrs.payload.modal_id : null
      if (modalId) {
        this.$store.commit('modals/removeModalById', modalId)
      }
      this.onStatusChange()
    },
    onClickTimingChange () {
      const modalId = this.$attrs.payload ? this.$attrs.payload.modal_id : null
      if (modalId) {
        this.$store.commit('modals/removeModalById', modalId)
      }
      this.onTimingChange()
    }
  }
}
</script>

<style scoped>
.buttons {
  margin-top: 1.5rem;
  gap: 2rem;
}

button {
  font-weight: 600;
}

.button-with-spacing {
  margin: 0 1.5rem;
}
</style>
